import Model from './model';

export default class LogicBaseStory extends Model {
  constructor(_id, owner, url, title, description, createTime, error) {
    super();
    this._id = _id;
    this.owner = owner;
    this.url = url;
    this.title = title;
    this.description = description;
    this.createTime = createTime;
    this.error = error;
  }
  getJson = () => {
    const { _id, owner, url, title, description } = this;
    return { _id, o: owner, l: url, t: title, d: description };
  }
}
